import tenantApi from 'src/api/clients/tenant';
import { AssignEmployeesToEmployeeGroupPayload } from '../types/payload/assign-employees-to-employee-group.payload';
import { UnassignEmployeeFromEmployeeGroupPayload } from '../types/payload/unassign-employee-from-employee-group.payload';

export const assignEmployeesToEmployeeGroup = async ({
  employeeGroupToken,
  employeesTokens,
  bookingsDecisions,
  bookingsDecisionsReason,
}: AssignEmployeesToEmployeeGroupPayload): Promise<void> => {
  await tenantApi.post<void>(
    `/employee-groups/${employeeGroupToken}/assign-employees`,
    {
      employeesTokens,
      bookingsDecisions,
      bookingsDecisionsReason,
    },
  );
};

export const removeEmployeeFromEmployeeGroup = async ({
  employeeGroupToken,
  employeeToken,
  bookingsDecisions,
  bookingsDecisionsReason,
}: UnassignEmployeeFromEmployeeGroupPayload): Promise<void> => {
  await tenantApi.post<void>(
    `/employee-groups/${employeeGroupToken}/employee/${employeeToken}/unassign`,
    {
      bookingsDecisions,
      bookingsDecisionsReason,
    },
  );
};
